import styled from 'styled-components';
import { Drawer as MUIDrawer, Box } from '@mui/material';

interface IDrawerProps {
  width: number;
}

export const Drawer = styled(MUIDrawer)`
  justify-content: center;
  width: ${({ width }: IDrawerProps) => width}px;
  border: none;

  & .MuiDrawer-paper {
    width: ${({ width }: IDrawerProps) => width}px;
    box-sizing: border-box;
  }
`;

export const Wrapper = styled(Box)`
  display: flex;
  width: 100%;
  justify-content: center;
`;
